import React from "react";
import { Trans } from "react-i18next";
import { useTranslation } from "../../useTranslation";
import {
  Box,
  Typography,
  SelectionSet,
  SelectionSetLabel,
  SelectionSetInput,
  FlexBox
} from "@vp/swan";

export enum EmailPreference {
  None = "none",
  All = "all",
  No = "no",
  Fewer = "fewer"
}

interface EmailPreferencesProps {
  preference?: EmailPreference;
  onPreferenceChange?: (preference: EmailPreference) => void;
  wrappedProps?: any;
  applicableDiscount?: number;
}

const EmailPreferencesControl = (props: EmailPreferencesProps) => {
  const {
    onPreferenceChange,
    preference,
    applicableDiscount,
    wrappedProps
  } = props;
  const [t] = useTranslation("signUp");

  const emailsSelection = (): EmailPreference => {
    if (preference === undefined) {
      return EmailPreference.None;
    }

    return preference;
  };

  const emailPreferenceChanged = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    if (event.target.value && onPreferenceChange) {
      if (
        event.target.value === EmailPreference.All ||
        event.target.value === EmailPreference.No ||
        event.target.value === EmailPreference.Fewer
      ) {
        onPreferenceChange(event.target.value);
      }
    }
  };

  return (
    <Box {...wrappedProps}>
      <Typography component="p">
        <Trans
          i18nKey={
            applicableDiscount === undefined
              ? "signUp:exclusiveEmails.title"
              : "signUp:exclusiveEmails.discountTitle"
          }
          values={{ value: applicableDiscount }}
          components={[<strong />]}
        />
      </Typography>
      <SelectionSet
        id="receiveEmailsSet"
        skin="simple-column"
        variant="single-select"
        data-testid="receiveEmailsSet"
        selectedValue={emailsSelection()}
        onChange={emailPreferenceChanged}
      >
        <SelectionSetInput
          value={EmailPreference.All}
          data-testid="yesSendMore"
        >
          <SelectionSetLabel>
            {applicableDiscount === undefined
              ? t("exclusiveEmails.yesSendMore")
              : t("exclusiveEmails.discountYesSendMore")}
          </SelectionSetLabel>
        </SelectionSetInput>
        <SelectionSetInput value={EmailPreference.No} data-testid="noDontSend">
          <SelectionSetLabel>
            {t("exclusiveEmails.noDontSend")}
          </SelectionSetLabel>
        </SelectionSetInput>
        {(emailsSelection() === EmailPreference.No ||
          emailsSelection() === EmailPreference.Fewer) && (
          <>
            <Typography component="p">{t("fewerEmails.title")}</Typography>
            <FlexBox style={{ width: "100%" }}>
              <SelectionSetInput
                data-testid="fewerEmails"
                value={EmailPreference.Fewer}
              >
                <SelectionSetLabel>
                  {t("fewerEmails.yesFewer")}
                </SelectionSetLabel>
              </SelectionSetInput>
            </FlexBox>
          </>
        )}
      </SelectionSet>
    </Box>
  );
};

const EmailPreferences: React.FunctionComponent<EmailPreferencesProps> = React.memo(
  EmailPreferencesControl
);
export default EmailPreferences;
